










































import { Component, Vue } from 'vue-property-decorator'
import config from '@/config'
import { Product, DiscountOp } from '@/store/types'
import { Discount as PbDiscount } from 'proto/eshop/Basket_pb'

@Component({})
export default class DiscountItem extends Vue {
	private readonly currency = config.currency
	private readonly promoCode: string = this.$store.state.discount.code
	private readonly percent: number = this.$store.state.discount.percent
	private readonly amount100: number = this.$store.state.discount.amount100

	private get isPercent(): boolean {
		return this.$store.state.discount.percent > 0.001
	}

	private get isAmount(): boolean {
		return this.$store.state.discount.amount100 > 0
	}

	private get isForProducts(): boolean {
		return this.$store.state.discount.target === PbDiscount.Target.PRODUCTS_ONLY
	}

	private get isForDelivery(): boolean {
		return this.$store.state.discount.target === PbDiscount.Target.DELIVERY_ONLY
	}

	private get isForProductsList(): boolean {
		return this.$store.state.discount.target === PbDiscount.Target.PRODUCTS_LIST
	}

	private get discountedProducts(): string {
		let dop = new DiscountOp(this.$store.state.discount)
		return this.$store.state.products
			.filter((p: Product) => dop.isDiscountForProduct(p))
			.map((p: Product) => p.name)
			.join(', ')
	}

	onDelete() {
		this.$emit('delete')
	}
}
